import { ScreenType } from '../types';

export class ScreenManager {
  private screens: Map<string, HTMLElement> = new Map();
  private currentScreen: ScreenType = 'menu';
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  /** Register a screen element so the manager can show/hide it. */
  register(screen: ScreenType, element: HTMLElement): void {
    // All screens start hidden
    element.style.opacity = '0';
    element.style.display = 'none';
    element.style.transition = 'opacity 200ms ease-in-out';
    element.style.position = 'absolute';
    element.style.top = '0';
    element.style.left = '0';
    element.style.width = '100%';
    element.style.height = '100%';
    element.style.pointerEvents = 'none';

    this.screens.set(screen, element);
    this.container.appendChild(element);
  }

  /** Switch to a screen with a fade transition. Only one screen is visible at a time. */
  switchTo(screen: ScreenType): void {
    if (screen === this.currentScreen && this.screens.get(screen)?.style.display !== 'none') {
      return;
    }

    const from = this.screens.get(this.currentScreen);
    const to = this.screens.get(screen);

    if (!to) {
      console.warn(`ScreenManager: screen "${screen}" is not registered.`);
      return;
    }

    this.currentScreen = screen;

    // Immediate swap — no fade transition.
    // The fade was causing layout races where the canvas parent had zero dimensions.
    if (from && from !== to) {
      from.style.display = 'none';
      from.style.opacity = '0';
      from.style.pointerEvents = 'none';
    }

    to.style.display = 'flex';
    to.style.pointerEvents = 'auto';
    to.style.opacity = '1';
  }

  /** Get the currently active screen type. */
  getCurrent(): ScreenType {
    return this.currentScreen;
  }
}
